import { render } from "./Transactions.vue?vue&type=template&id=7304b621"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__